export default __webpack_public_path__ + "static/media/Belt of Crimson Slaughter.58e3595f.jpg";